<template>
    <div class="material-box">
        <div class="material-wrap relative" v-if="file" :style="{width:styleWidth}">
            <!-- <video v-if="fileType=='video'" :src="file.url"></video> -->
            <img alt="缩略图"
             :src="show_img"
             v-on:load="imageLoaded"
             v-on:error="imageFailed"
            >

            <div class="mask-con">
                <el-popover
                    placement="left"
                    width="500"
                    trigger="hover"
                    v-model="show"
                    popper-class="vivo-batch-material-pre-popover"
                    :show="handleShow"
                    :key="key"
                    :hide="handleHide">
                    <div class="pop-content">
                        <video class="pre-material" v-if="fileType=='video'&&show" :src="file.url || file.full_material_url" controls style="max-width: 100%;"></video>
                        <img class="pre-material" v-else-if="show" :src="show_img" alt="图" style="max-width: 100%;">
                    </div>
                    <div slot="reference">
                        <span class="pre-btn action-btn">预览</span>
                    </div>
                </el-popover>

                <!-- <span v-if="!isAimedia" class="copy-btn action-btn" @click="copy">复制</span> -->
            </div>
            <!-- <div class="remove-btn">
                <span class="el-icon-error remove-btn-icon" title="删除" @click="remove"></span>
            </div> -->
        </div>
        <!-- <p class="ellipsis wfull title-text" :title="file.name || file.material_name">{{file.name || file.material_name}}</p> -->
    </div>
</template>

<script>
import noImg from '@/assets/img/mi-no-img.png'
    export default {
        name: "MaterialItem",
        props:{
            type:{
                required: true,
                type:String,
                default:'image',
            },
            file:{
                required: true,
                type:Object,
            },
            height:[String,Number],
            width:[String,Number],
            isAimedia: Boolean
        },
        computed:{
            styleWidth(){
                if(!this.width||!this.height) return 'auto';
                return Math.floor(this.width * 100 / this.height)+'px';
            },
            fileType(){
                let type = (this.type||'').toLowerCase();
                return (type.includes('video')||type.includes('mp4'))?'video':'image';
            }
        },
        watch: {
            'file': {
                handler() {
                    this.show_img = this.file.img_full_material_url ? this.file.img_full_material_url : ''
                },
                deep: true,
                immediate: true
            }
        },
        data(){
            return {
                show: false,
                showContent: false,
                show_img:'',
                no_img: noImg,
                key: 1
            }
        },
        methods:{
            videoLoaded(){
                this.key = 2;
            },
            copy(){
                this.$emit('copy',this.file);
            },
            remove(){
                this.$emit('remove', this.file);
            },
            handleShow() {
                this.show = true;
            },
            handleHide() {
                this.show = false
            },
            imageLoaded() {
            },
            imageFailed() {
                this.show_img = this.no_img
            },
        },
    }
</script>

<style lang="scss" scoped>
    .material-box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .title-text{
            line-height: 12px;
            width: 100%;
        }
    }
    .material-wrap{
        height: 60px;
        margin: 5px;
        max-width: 80%;
        min-width: 80px;
        border: dashed 1px #ccc;
        text-align: center;
        &:hover .mask-con{
            opacity: 1;
        }
        img,video{
            max-height: 100%;
            max-width: 100%;
        }


        .remove-btn{
            line-height: 10px;
            position: absolute;
            right: -6px;
            top: -6px;
            z-index: 3;
            cursor: pointer;
            background-color: #fff;
            border-radius: 50%;
            width: 12px;
            height: 12px;
            .remove-btn-icon{
                color: red;
            }
        }
        .mask-con{
            display: flex;
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            background-color: rgba(0,0,0,0.7);
            align-items: center;
            justify-content: center;
            .action-btn{
                color: #fff;
                margin: 0 6px;
                cursor: pointer;
                display: block;
                &:hover{
                    text-decoration: underline;
                }
            }
        }
    }
</style>
<style lang="scss">
    .el-popover.vivo-batch-material-pre-popover{
        .pop-content{
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 100%;
            height: 100%;

            video,img{
                max-height: 400px;
                max-width: 500px;
            }
        }

    }
</style>
